import { render } from "./opening_page.vue?vue&type=template&id=22e23667&scoped=true"
import script from "./opening_page.vue?vue&type=script&lang=js"
export * from "./opening_page.vue?vue&type=script&lang=js"

import "./opening_page.vue?vue&type=style&index=0&id=22e23667&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e23667"]])

export default __exports__